module.exports = __webpack_public_path__ + "static/inland-marine-insurance-93566b9a95f9dda01ddaf355f04d1eb0.svg";